import { createContext, useState, useContext, ReactNode } from "react";
import {
  CartPaymentSummaryModel,
  CustomerCardModel,
  PaymentModel,
} from "../models";
import { Payments, GooglePay, ApplePay } from "@square/web-sdk";

type PaymentContextType = {
  squarePayments: Payments | undefined;
  setSquarePayments: (squarePayments: Payments | undefined) => void;
  card: any;
  setCard: (card: any) => void;
  saveCard: boolean;
  setSaveCard: (checked: boolean) => void;
  savedCard: CustomerCardModel | undefined;
  setSavedCard: (card: CustomerCardModel) => void;
  applePay: ApplePay | undefined;
  setApplePay: (applePay: ApplePay | undefined) => void;
  googlePay: GooglePay | undefined;
  setGooglePay: (googlePay: GooglePay | undefined) => void;
  payment: PaymentModel[];
  setPayment: (payment: PaymentModel[]) => void;
  mode: string;
  setMode: (mode: string) => void;
  giftcardCode: string;
  setGiftcardCode: (code: string) => void;
  paymentBreakup: CartPaymentSummaryModel;
  setPaymentBreakup: (breakup: CartPaymentSummaryModel) => void;
  resetPayment: () => void;
};

const PaymentContext = createContext({} as PaymentContextType);

export function usePayment() {
  return useContext(PaymentContext);
}

const defaultMode = "";
const defaultPaymentBreak: CartPaymentSummaryModel = {
  subtotal: 0,
  tax: 0,
  shipping: 0,
  convenience: 0,
  discount: 0,
  tip: 0,
  order_total: 0,
  to_pay: 0,
  loyalty: 0,
  giftcard: 0,
};

export function PaymentProvider({ children }: { children: ReactNode }) {
  const [squarePayments, setSquarePayments] = useState<Payments | undefined>();
  const [card, setCard] = useState<any>(null);
  const [saveCard, setSaveCard] = useState<boolean>(false);
  const [savedCard, setSavedCard] = useState<CustomerCardModel>();
  const [applePay, setApplePay] = useState<ApplePay | undefined>();
  const [googlePay, setGooglePay] = useState<GooglePay | undefined>();
  const [payment, setPayment] = useState<PaymentModel[]>([]);
  const [mode, setMode] = useState<string>(defaultMode);
  const [giftcardCode, setGiftcardCode] = useState<string>("");
  const [paymentBreakup, setPaymentBreakup] =
    useState<CartPaymentSummaryModel>(defaultPaymentBreak);

  const resetPayment = () => {
    setMode(defaultMode);
    setPaymentBreakup(defaultPaymentBreak);
  };

  return (
    <PaymentContext.Provider
      value={{
        squarePayments,
        setSquarePayments,
        card,
        setCard,
        saveCard,
        setSaveCard,
        savedCard,
        setSavedCard,
        applePay,
        setApplePay,
        googlePay,
        setGooglePay,
        payment,
        setPayment,
        mode,
        setMode,
        giftcardCode,
        setGiftcardCode,
        paymentBreakup,
        setPaymentBreakup,
        resetPayment,
      }}
    >
      {children}
    </PaymentContext.Provider>
  );
}
